exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.ng-invalid.ng-touched {\n    border: 1px solid red;\n}\n\n.error {\n  color: red;\n}\n\n.btn-sf {\n  background-color: #0A73B8;\n}\n\n.nopadding {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/auth/login/login.component.css
// module id = ../../../../../src/app/auth/login/login.component.css
// module chunks = main